import {View} from "../../km_app/types/View";
import {ApplicationSourceSection} from "../../lead/types/ApplicationSourceSection";
import {PropertyListType} from "../types/IPropertyListType";
import {IPropertyState} from "../types/IPropertyState";

export const propertyFormModalInitialState: IPropertyState["formModal"] = {
    isOpen: false,
    itemId: 0,
    itemType: PropertyListType.Recommendation,
    sourceSection: ApplicationSourceSection.PropertyBoxLeadModal,
    viewType: View.MY_OFFER
};
import {View} from "../../km_app/types/View";
import {ApplicationSourceSection} from "../../lead/types/ApplicationSourceSection";
import {PropertyListType} from "../types/IPropertyListType";
import {IPropertyState} from "../types/IPropertyState";

export const propertyFormModalInitialState: IPropertyState["formModal"] = {
    isOpen: false,
    itemId: 0,
    itemType: PropertyListType.Recommendation,
    sourceSection: ApplicationSourceSection.PropertyBoxLeadModal,
    viewType: View.MY_OFFER
};
